import React, { useEffect } from 'react';
import { useUpload } from '../contexts/UploadContext';
import { ProgressBar, Button } from 'react-bootstrap';

const UploadNotification = () => {
    const { uploads, removeUpload, cancelUpload } = useUpload();

    // Efeito para fechar automaticamente quando todos os uploads estiverem concluídos
    useEffect(() => {
        const allCompleted = uploads.every(upload => 
            upload.status === 'completed' || 
            upload.status === 'failed' || 
            upload.status === 'canceled'
        );

        if (allCompleted && uploads.length > 0) {
            const timer = setTimeout(() => {
                uploads.forEach(upload => removeUpload(upload.id));
            }, 2000); // Aguarda 2 segundos antes de fechar

            return () => clearTimeout(timer);
        }
    }, [uploads, removeUpload]);

    if (uploads.length === 0) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '18vw',
            zIndex: 9999,
            backgroundColor: '#1a1a1a',
            borderRadius: '8px',
            padding: '15px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            minWidth: '400px',
            maxWidth: '500px'
        }}>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h6 className="mb-0" style={{ color: '#fff' }}>Uploads em andamento</h6>
                {/* <Button
                    variant="link"
                    className="p-0 text-white"
                    onClick={() => uploads.forEach(upload => removeUpload(upload.id))}
                >
                    <span className="material-symbols-outlined" style={{ fontSize: 20 }}>close</span>
                </Button> */}
            </div>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {uploads.map(upload => (
                    <div key={upload.id} style={{ marginBottom: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                            <span style={{ color: '#fff', fontSize: '0.9rem' }}>
                                {upload.file.name.length > 20 
                                    ? upload.file.name.slice(0, 20) + '...' 
                                    : upload.file.name}
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {(upload.status === 'pending' || upload.status === 'uploading') && (
                                    <Button
                                        variant="link"
                                        className="p-0 text-danger"
                                        onClick={() => cancelUpload(upload.id)}
                                        style={{ fontSize: '0.8rem' }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>cancel</span>
                                    </Button>
                                )}
                            </div>
                        </div>
                        <ProgressBar
                            now={upload.status === 'completed' ? 100 : 
                                 upload.status === 'failed' ? 100 : 
                                 upload.status === 'canceled' ? 100 :
                                 100}
                            animated={upload.status === 'pending' || upload.status === 'uploading'}
                            variant={upload.status === 'failed' ? 'danger' : 
                                    upload.status === 'completed' ? 'success' : 
                                    upload.status === 'canceled' ? 'warning' :
                                    'primary'}
                            label={
                                upload.status === 'completed'
                                    ? 'Concluído'
                                    : upload.status === 'failed'
                                    ? 'Erro'
                                    : upload.status === 'canceled'
                                    ? 'Cancelado'
                                    : 'Carregando...'
                            }
                        />
                        {upload.status === 'error' && (
                            <small style={{ color: '#dc3545', display: 'block', marginTop: '5px' }}>
                                Erro: {upload.error}
                            </small>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UploadNotification; 